import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { forkJoin } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { CommunityService } from '../../services/community.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, OnDestroy {

    newNotificationFormGroup!: FormGroup;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private communityService: CommunityService,
        private formBuilder: FormBuilder
    ) {
    }

    ngOnInit() {
        this.newNotificationFormGroup = this.formBuilder.group({
            newNotificationTitle: [null, Validators.required],
            newNotificationBody: [null, Validators.required],
            newNotificationTargetCS: [false, /*Validators.required*/],
            newNotificationTargetDE: [false, /*Validators.required*/],
            newNotificationTargetEL: [false, /*Validators.required*/],
            newNotificationTargetEN: [false, /*Validators.required*/],
            newNotificationTargetES: [false, /*Validators.required*/],
            newNotificationTargetFR: [false, /*Validators.required*/],
            newNotificationTargetHE: [false, /*Validators.required*/],
            newNotificationTargetIT: [false, /*Validators.required*/],
            newNotificationTargetJA: [false, /*Validators.required*/],
            newNotificationTargetKO: [false, /*Validators.required*/],
            newNotificationTargetNL: [false, /*Validators.required*/],
            newNotificationTargetPL: [false, /*Validators.required*/],
            newNotificationTargetRU: [false, /*Validators.required*/],
            newNotificationTargetTH: [false, /*Validators.required*/],
            newNotificationTargetZH: [false, /*Validators.required*/]
        });
    }

    ngOnDestroy() {
    }

    get noTarget() {
        return [
            this.newNotificationFormGroup.value.newNotificationTargetCS,
            this.newNotificationFormGroup.value.newNotificationTargetDE,
            this.newNotificationFormGroup.value.newNotificationTargetEL,
            this.newNotificationFormGroup.value.newNotificationTargetEN,
            this.newNotificationFormGroup.value.newNotificationTargetES,
            this.newNotificationFormGroup.value.newNotificationTargetFR,
            this.newNotificationFormGroup.value.newNotificationTargetHE,
            this.newNotificationFormGroup.value.newNotificationTargetIT,
            this.newNotificationFormGroup.value.newNotificationTargetJA,
            this.newNotificationFormGroup.value.newNotificationTargetKO,
            this.newNotificationFormGroup.value.newNotificationTargetNL,
            this.newNotificationFormGroup.value.newNotificationTargetPL,
            this.newNotificationFormGroup.value.newNotificationTargetRU,
            this.newNotificationFormGroup.value.newNotificationTargetTH,
            this.newNotificationFormGroup.value.newNotificationTargetZH
        ].every(target => !target)
    }

    selectAll() {
        [
            this.newNotificationFormGroup.controls['newNotificationTargetCS'],
            this.newNotificationFormGroup.controls['newNotificationTargetDE'],
            this.newNotificationFormGroup.controls['newNotificationTargetEL'],
            this.newNotificationFormGroup.controls['newNotificationTargetEN'],
            this.newNotificationFormGroup.controls['newNotificationTargetES'],
            this.newNotificationFormGroup.controls['newNotificationTargetFR'],
            this.newNotificationFormGroup.controls['newNotificationTargetHE'],
            this.newNotificationFormGroup.controls['newNotificationTargetIT'],
            this.newNotificationFormGroup.controls['newNotificationTargetJA'],
            this.newNotificationFormGroup.controls['newNotificationTargetKO'],
            this.newNotificationFormGroup.controls['newNotificationTargetNL'],
            this.newNotificationFormGroup.controls['newNotificationTargetPL'],
            this.newNotificationFormGroup.controls['newNotificationTargetRU'],
            this.newNotificationFormGroup.controls['newNotificationTargetTH'],
            this.newNotificationFormGroup.controls['newNotificationTargetZH']
        ].forEach(control => control.patchValue(true))
    }

    selectNone() {
        [
            this.newNotificationFormGroup.controls['newNotificationTargetCS'],
            this.newNotificationFormGroup.controls['newNotificationTargetDE'],
            this.newNotificationFormGroup.controls['newNotificationTargetEL'],
            this.newNotificationFormGroup.controls['newNotificationTargetEN'],
            this.newNotificationFormGroup.controls['newNotificationTargetES'],
            this.newNotificationFormGroup.controls['newNotificationTargetFR'],
            this.newNotificationFormGroup.controls['newNotificationTargetHE'],
            this.newNotificationFormGroup.controls['newNotificationTargetIT'],
            this.newNotificationFormGroup.controls['newNotificationTargetJA'],
            this.newNotificationFormGroup.controls['newNotificationTargetKO'],
            this.newNotificationFormGroup.controls['newNotificationTargetNL'],
            this.newNotificationFormGroup.controls['newNotificationTargetPL'],
            this.newNotificationFormGroup.controls['newNotificationTargetRU'],
            this.newNotificationFormGroup.controls['newNotificationTargetTH'],
            this.newNotificationFormGroup.controls['newNotificationTargetZH']
        ].forEach(control => control.patchValue(false))
    }

    send() {

        let formGroup: FormGroup = this.newNotificationFormGroup;

        let title = formGroup.value.newNotificationTitle.trim();
        let body = formGroup.value.newNotificationBody.trim();
        let locales: any[] = [];
        locales.push(formGroup.value.newNotificationTargetCS ? 'cs' : false);
        locales.push(formGroup.value.newNotificationTargetDE ? 'de' : false);
        locales.push(formGroup.value.newNotificationTargetEL ? 'el' : false);
        locales.push(formGroup.value.newNotificationTargetEN ? 'en' : false);
        locales.push(formGroup.value.newNotificationTargetES ? 'es' : false);
        locales.push(formGroup.value.newNotificationTargetFR ? 'fr' : false);
        locales.push(formGroup.value.newNotificationTargetHE ? 'he' : false);
        locales.push(formGroup.value.newNotificationTargetIT ? 'it' : false);
        locales.push(formGroup.value.newNotificationTargetJA ? 'ja' : false);
        locales.push(formGroup.value.newNotificationTargetKO ? 'ko' : false);
        locales.push(formGroup.value.newNotificationTargetNL ? 'nl' : false);
        locales.push(formGroup.value.newNotificationTargetPL ? 'pl' : false);
        locales.push(formGroup.value.newNotificationTargetRU ? 'ru' : false);
        locales.push(formGroup.value.newNotificationTargetTH ? 'th' : false);
        locales.push(formGroup.value.newNotificationTargetZH ? 'zh' : false);

        this.progressIndicatorService.progress = true;
        forkJoin(
            locales.filter(locale => locale).map(locale => this.communityService.sendNotification(title, body, [locale]))
        ).subscribe({
            next: (value: any) => {
                console.log('NotificationComponent.send.communityService.sendNotification.value', value);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.newNotificationFormGroup.reset();
            },
            error: (error: any) => {
                console.log('NotificationComponent.send.communityService.sendNotification.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.success('Success');
                this.newNotificationFormGroup.reset();
            }
        });
    }

    erase() {
        this.newNotificationFormGroup.reset();
    }
}
